import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import { addClient, updateClient } from "src/store/client";
import { ValidationMessages } from 'src/components/common/ValidationMessage';
import { resetStateIdele } from 'src/store/client';

const ClientConfirm = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();

    const { formData } = location.state || {};
    const client = useSelector((state) => state.client);
    const [validationMessages, setValidationMessages] = useState([]);

    const clickBackBtn = () => {
        if (formData.id) {
            navigate(`/clientEdit/${formData.id}`, { state: { formData: formData } });
        }
        else {
            navigate("/clientinput", { state: { formData: formData } });
        }
    };

    const clickRegBtn = () => {
        if (formData.id) {
            dispatch(updateClient(formData))
            .then((response) => {
                if (response.payload.errors) {
                    setValidationMessages(response.payload.errors);
                }
                if (response.payload.status === 500) {
                    setValidationMessages(response.payload.message);
                }
            })
            .catch((error) => {
                setValidationMessages([error.message]);
            });
        } else {
            dispatch(addClient(formData))
            .then((response) => {
                if (response.payload.errors) {
                    setValidationMessages(response.payload.errors);
                }
                if (response.payload.status === 500) {
                    setValidationMessages(response.payload.message);
                }
            })
            .catch((error) => {
                setValidationMessages([error.message]);
            });
        }
    };

    const clickClientListBtn = () => {
        navigate('/clientList');
    };

    useEffect(() => {
        if (client.status === 'succeeded') {
            resetStateIdele();
            clickClientListBtn();
        } else {
            setValidationMessages(client.errors);
        }
    }, [client.status, client.errors]);

    return (
        <div className="wrapper">
            {validationMessages && validationMessages.length > 0 && (
                <div style={{ background: "#ffe4e2" }}>
                    <ValidationMessages
                        messages={validationMessages}
                        onClose={() => setValidationMessages([])}
                    />
                </div>
            )}
            <section className="container-fluid contents-top">
                <div className="text-right">
                    <button type="button" className="btn btn-default" onClick={clickClientListBtn}><span
                        className="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>Back to List</button>
                </div>

                <div className="" style={{ width: "90%", margin: "0 auto" }}>
                    {formData.id ? (
                        <h3 className="title-style01">Modify Client Registration</h3>
                    ) : (
                        <h3 className="title-style01">New Client Registration</h3>
                    )}
                    <div className="form-group div-height">
                        <label className="col-sm-3 control-label" style={{ textAlign: "end", marginTop: 6 }}>
                            Name *
                        </label>
                        <div className="col-sm-9">
                            <p
                                className="form-control confirm_style"
                                style={{
                                    wordWrap: "break-word", // Ensures words break to fit within the container
                                    overflowWrap: "break-word", // Handles long strings without spaces
                                    whiteSpace: "normal", // Ensures text wraps to the next line
                                }}
                            >
                                {formData?.name}
                            </p>
                        </div>
                    </div>
                    <div className="form-group div-height">
                        <label className="col-sm-3 control-label" style={{ textAlign: "end", marginTop: 6 }}>
                            Remarks
                        </label>
                        <div className="col-sm-9">
                            <p
                                className="form-control confirm_style"
                                style={{
                                    wordWrap: "break-word",
                                    overflowWrap: "break-word",
                                    whiteSpace: "normal",
                                }}
                            >
                                {formData?.memo}
                            </p>
                        </div>
                    </div>
                    <div className="form-group text-center" style={{ marginTop: 260 }}>
                        <button type="button" onClick={clickBackBtn} className="btn btn-default btn-lg jq-re_edit_data" style={{ marginRight: 20 }}>
                            Back
                        </button>
                        <button type="button" onClick={clickRegBtn} className="btn btn-success btn-lg jq-regester_data">
                            {formData.id ? "Update" : "Register"}
                        </button>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ClientConfirm;